import { render, staticRenderFns } from "./MidiaBlock.vue?vue&type=template&id=b5cd5f9c&scoped=true&"
import script from "./MidiaBlock.vue?vue&type=script&lang=js&"
export * from "./MidiaBlock.vue?vue&type=script&lang=js&"
import style0 from "./MidiaBlock.vue?vue&type=style&index=0&id=b5cd5f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd5f9c",
  null
  
)

export default component.exports